import Jtb from './Jtb';

import { SmartLink } from '../../fragments/smart-link/SmartLink';
import Button from '../../fragments/button/Button';

export default function Row({ block }) {
  // Scroll to the top using Lenis when available, falling back to native smooth scroll.
  const scrollToTop = () => {
    if (typeof window === 'undefined') return;

    if (window.lenis) {
      window.lenis.scrollTo(0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <div className="NavigationFooter-row">
        <Jtb />

        {block.copyright && (
          <p className="NavigationFooter-copyright text--size-xs">
            {block.copyright}
          </p>
        )}

        <Button
          buttonLabel="Back to top"
          className="NavigationFooter-backToTop"
          icon="arrowUp"
          theme="tertiary"
          size="small"
          onClick={scrollToTop}
        />
      </div>
    </>
  );
}
